import React,{useState,useEffect} from 'react'
import corplap from '../Assets/Images/Corplap.png'
import { BASE_URL } from '../Config/Base';
const CorpdashboardMain = () => {

    const token = JSON.parse(localStorage.getItem('usertoken'));
    const [allusers,setAllusers]= useState([])

    useEffect(()=>{
        Getusers();
        GetAssignusers();
        getCorprole();
       
      },[])
    
    
      function Getusers(){
    
        console.log("Token",token)
    
        fetch(`${BASE_URL}/Kdpcorp/GetCorpUsers`, {
         
        method:'GET',
    
          headers : {
    
            "Content-type": "application/json",
    
            "Accept": "application/json",
      
            "Authorization": "Bearer " + `${token}`,
      
            "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
          },
    
          //body:JSON.stringify(data)
    
        }).then(response => response.json())
        .then(data => {
          console.log("Data",data)
          setAllusers(data)
         // setpaginatedPosts(_(data).slice(0).take(pageSize).value());
          localStorage.setItem("CorpUsers",JSON.stringify(data))
        });
    
        console.log("check",allusers)
      }




      function GetAssignusers(){
        console.log("Token",token)
      
          fetch(`${BASE_URL}/Kdpcorp/GetCorpAssignUser`,{
      
            method:"GET",
            headers:{
              "Content-type": "application/json",
      
              "Accept": "application/json",
        
              "Authorization": "Bearer " + `${token}`,
        
              "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
            },
               //body:JSON.stringify(data)
      
          }).then(response=> response.json())
          .then(data=>{
            console.log("Data",data)
            setAllusers(data)
         
            localStorage.setItem("corpassignuserData", JSON.stringify(data));
          });
      
          console.log("check",allusers)
        }
      

        function getCorprole(){


          fetch(`${BASE_URL}/Kdpcorp/GetCorpAddRole`, {
            method:'GET',
        
          headers : {
        
            "Content-type": "application/json",
        
            "Accept": "application/json",
        
            "Authorization": "Bearer " +`${token}`,
        
            "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
          },
        
        
        })
        
        .then(response => response.json())
        
        
        .then(data => {
        console.log("Section",data)
        // setRoletable(data)
        setAllusers(data)
        // setpaginatedPosts(_(data).slice(0).take(pageSize).value());
        
        localStorage.setItem("corpaddroleData", JSON.stringify(data));
        });
        console.log("check",allusers)
        }

  return (
    <>

<div className='Corp-addmain mnb'>
    
    {/* <div className='Corp-dash' >

    <div className='Corp-addmain' id="Corppicture">
        </div>
        <div className='Corp-head'></div>
</div> */}


<main class="flex padding_2x" id="corp-welcomemain">
    <section class="flex-content padding_2x" >
        <article>
            <h1 class="title medium" id="corpsection">WELCOME TO KDPCORP</h1>
           <hr></hr> <p>We serve the Construction and Real Estate, Information Technology, and Accounting and
Financial Industries in India and the Global Market</p>
            <p>We design solutions with our extensive knowledge that enhance your business processes
however complex they may be</p>
<p>Our whole team of professionals is about building lasting relationships. Throw in dedication,
great people and an obsession to be the best and now you’ve got an idea of how we go about
our day</p>
            
        </article>
    </section>
    <section class="flex-content padding_2x">
        <img src={corplap} alt="" loading="lazy"/><hr></hr>
    </section>
</main>

</div>

</>
  )
}

export default CorpdashboardMain